module.exports = __webpack_public_path__ + "img/myself01.928640a8.png";